<template>
  <div id="resources" class="row">
    <div class="col-12">
      <div class=" panel-body bg-white pl-0 pr-0">
        <table v-if="resources && resources.length > 0" id="booking-resources" class="table text-center">
          <thead>
          <tr>
            <th>{{ $t("input.type") }}</th>
            <th>{{ $t("input.received_at") }}</th>
            <th>{{ $t("button.actions") }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="resource in resources">
            <td>
              {{ getResourceName(resource.type) }}
            </td>
            <td>
              {{ getReceivedDate(resource.created_at) }}
            </td>
            <td>
              <div class="d-flex align-items-center justify-content-center">
                <div class="btn-group">
                  <div class="dropdown">
                    <div class="btn-group">
                      <div class="dropdown">
                        <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown"><i class="bulle"></i></button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a href="#" class="dropdown-item waves-effect waves-light waves-round" @click.prevent="openViewDocumentModal(resource)">{{ $t("booking.detail.resources.view_document") }}</a>
                          <a href="#" class="dropdown-item waves-effect waves-light waves-round" @click.prevent="removeResource(resource.id)">{{ $t("button.delete") }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <div v-else class="pl-5 pt-10">
          {{ $t("booking.detail.resources.no_resource") }}
        </div>
      </div>

    </div>

    <v-view-document-modal
      :resource="resource"
    />
  </div>
</template>

<script>
    import moment from "moment";
    import mixin from "../../../mixins/mixin";
    import fileService from "../../../services/file";

    export default {
        name: "Resources",
        data() {
          return {
            resource: {}
          }
        },
        props: [
          'resources'
        ],
        components: {
          VViewDocumentModal: require('./modals/ViewDocumentModal')
        },
        mixins: [mixin],
        methods: {
          getReceivedDate(date) {
            return moment(date).format('DD MMM YYYY HH:mm:ss');
          },
          openViewDocumentModal(resource) {
            this.resource = {...resource};
            this.openModal('#view-document');
          },
          getResourceName(type) {
            return type === 'passport' ? 'Passeport' : 'Credit card'
          },
          async removeResource(id) {
            swal({
                title: this.$t('rentals.detail.modals.are_you_sure'),
                text: `<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>${this.$t("rentals.detail.modals.can_not_recover_document")}</div>`,
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-warning",
                confirmButtonText: this.$t('rentals.detail.modals.yes_delete_it'),
                closeOnConfirm: false,
                html: true
              },
              async () => {
                $(".cancel").addClass("disabled");
                $(".confirm").addClass("disabled");
                $(".pulseWarning").hide();
                $("#loading1").show();

                await fileService.removeResource(this, id, false);
                this.$emit('getResources');
              });
          }
        }
    }
</script>



// WEBPACK FOOTER //
// Resources.vue?4b0eb16f